import BigNumber from "bignumber.js";

/**
 * 숫자를 지정된 소수점 자리수로 포맷팅하는 범용 함수
 * @param value - 포맷팅할 숫자 값
 * @param decimalPlaces - 소수점 자리수 (기본값: 2)
 * @param roundingMode - 반올림 모드 (기본: ROUND_DOWN)
 * @returns 지정된 소수점 자리수로 포맷팅된 문자열
 */
export const formatDecimal = (
  value: number | string,
  decimalPlaces: number = 2,
  roundingMode = BigNumber.ROUND_DOWN
): string => {
  if (value === undefined || value === null || value === '') return '0';

  try {
    const n = new BigNumber(value);
    BigNumber.config({ ROUNDING_MODE: roundingMode });
    return n.decimalPlaces(decimalPlaces).toString();
  } catch (e) {
    console.error("formatDecimal BigNumber 변환 오류:", e);
    return Number(value).toFixed(decimalPlaces);
  }
};

/**
 * 숫자를 소수점 4자리까지만 표시하는 함수 (반올림)
 * @param value - 포맷팅할 숫자 값
 * @returns 소수점 4자리까지 반올림된 문자열
 */
// export const formatDecimal4 = (value: number | string): string => {
//   if (value === undefined || value === null || value === '') return '0';
//   return Number(value).toFixed(4);
// };

/**
 * 숫자를 소수점 4자리까지만 표시하는 함수 (버림, 반올림 없음)
 * 천 단위 콤마 추가, 소수점 앞에 공백 추가
 * @param value - 포맷팅할 숫자 값
 * @returns 소수점 4자리까지 버림되고 천 단위 콤마가 추가된 문자열
 */
export const formatDecimal4Truncate = (value: number | string): string => {
  if (value === undefined || value === null || value === '') return '0';
  
  const strValue = value.toString();
  const decimalPos = strValue.indexOf('.');
  
  if (decimalPos === -1) return strValue;
  return strValue.substring(0, decimalPos + 5); // 소수점 + 최대 4자리
};

/**
 * BigNumber를 사용하여 소수점 4자리까지 표시하는 함수
 * 큰 숫자나 정밀한 계산이 필요한 경우 사용
 * @param value - 포맷팅할 숫자 값
 * @param roundingMode - 반올림 모드 (기본: BigNumber.ROUND_DOWN)
 * @returns 소수점 4자리까지 포맷팅된 문자열
 */
export const formatBigDecimal4 = (
  value: number | string,
  roundingMode = BigNumber.ROUND_DOWN
): string => {
  if (value === undefined || value === null || value === '') return '0';
  
  try {
    const n = new BigNumber(value);
    // 반올림 모드 설정
    BigNumber.config({ ROUNDING_MODE: roundingMode });
    return n.decimalPlaces(4).toString();
  } catch (e) {
    console.error("BigNumber 변환 오류:", e);
    return formatDecimal4Truncate(value);
  }
};

/**
 * 입력값에서 소수점 4자리까지만 허용하는 함수
 * 주로 입력 필드의 onChange 핸들러에서 사용
 * @param inputValue - 사용자 입력 값
 * @returns 소수점 4자리까지만 허용된 문자열
 */
// export const limitToDecimal4 = (inputValue: string): string => {
//   if (!inputValue) return '';
  
//   // 소수점 포함 여부 확인
//   if (inputValue.includes('.')) {
//     const [integer, decimal] = inputValue.split('.');
//     // 소수점 이하 4자리까지만 허용
//     if (decimal && decimal.length > 4) {
//       return `${integer}.${decimal.substring(0, 4)}`;
//     }
//   }
  
//   return inputValue;
// }; 